import { ADD_LANGUAGE, ADD_MARKETPLACE, ADD_TOLGEE_STATIC_DATA } from './actionTypes';
import { DEFAULT_STATE } from './constants';
export function reducer(state = DEFAULT_STATE, action) {
    switch (action.type) {
        case ADD_LANGUAGE:
            return Object.assign(Object.assign({}, state), { language: action.payload.language });
        case ADD_MARKETPLACE:
            return Object.assign(Object.assign({}, state), { marketplace: action.payload.marketplace });
        case ADD_TOLGEE_STATIC_DATA:
            if (action.payload.ssrStaticData) {
                return Object.assign(Object.assign({}, state), { ssrStaticData: [...(state.ssrStaticData || []), ...action.payload.ssrStaticData] });
            }
            else {
                return state;
            }
        default:
            return state;
    }
}
